import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    Login: undefined
  },
  getters: {
  },
  mutations: {
    setUser(state, info) {
      state.user = info
    },
    setLogin(state, info) {
      state.Login = info
    }
  },
  actions: {
  },
  modules: {
  }
})
